import { Injectable } from '@angular/core';
import { TableColumnService } from '../services/table-column.service';
import { TableColumnProvider } from '../../../interfaces/table-column-provider';
import { TableColumn } from 'src/app/models/table-column';
import { CommodityColumnEnum } from '../../../enum/commodity-column.enum';
import { EntityEnum } from '../../../enum/entity.enum';
import { Commodity } from '../../../models/commodity';
import { Weight } from '../../../utils/weight';
import { Currency } from '../../../utils/currency';
import { countries } from '../../../list/countries';

@Injectable({
    providedIn: 'root'
})
export class CommodityColumnsService implements TableColumnProvider {

    constructor(private tableColumnService: TableColumnService) {
        this.tableColumnService.registerProvider(this);
    }

    supports(entityClass: string): boolean {
        return entityClass === EntityEnum.COMMODITY;
    }

    ids(): string[] {
        return [
            CommodityColumnEnum.COMMODITY_DESCRIPTION,
            CommodityColumnEnum.COMMODITY_WEIGHT,
            CommodityColumnEnum.COMMODITY_HS_CODE,
            CommodityColumnEnum.COMMODITY_COUNTRY,
            CommodityColumnEnum.COMMODITY_VALUE
        ];
    }

    get(id: string): TableColumn {
        switch (id) {
            case CommodityColumnEnum.COMMODITY_DESCRIPTION:
                return {
                    id: CommodityColumnEnum.COMMODITY_DESCRIPTION,
                    caption: $localize`Description`,
                    width: 200,
                    sort: 'description',
                    render: (entity: Commodity) => entity.description
                };
                case CommodityColumnEnum.COMMODITY_WEIGHT:
                    return {
                        id: CommodityColumnEnum.COMMODITY_WEIGHT,
                        caption: $localize`Weight`,
                        width: 100,
                        sort: 'weight',
                        render: (entity: Commodity) => Weight.render(entity.weight, entity.weightUnit)
                    };
            case CommodityColumnEnum.COMMODITY_HS_CODE:
                return {
                    id: CommodityColumnEnum.COMMODITY_HS_CODE,
                    caption: $localize`HS Code`,
                    width: 100,
                    sort: 'hsCode',
                    render: (entity: Commodity) => entity.harmonizedCode
                };
            case CommodityColumnEnum.COMMODITY_COUNTRY:
                return {
                    id: CommodityColumnEnum.COMMODITY_COUNTRY,
                    caption: $localize`Country`,
                    width: 100,
                    sort: 'country',
                    render: (entity: Commodity) => countries.find(c => c.code === entity.country)?.name
                };
            case CommodityColumnEnum.COMMODITY_VALUE:
                return {
                    id: CommodityColumnEnum.COMMODITY_VALUE,
                    caption: $localize`Value`,
                    width: 100,
                    sort: 'value',
                    render: (entity: Commodity) => Currency.render(entity.price, entity.currency) + ' ' + entity.currency
                };
            default:
                throw new Error(`'Unrecognized column "${id}"`);
        }
    }
}
